import React, { Suspense, lazy } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import Layout from './components/Layout';

// Lazy load components
const Landing = lazy(() => import('./pages/Landing'));
const Dashboard = lazy(() => import('./pages/Dashboard'));
const DebtCalculator = lazy(() => import('./pages/DebtCalculator'));
const Reports = lazy(() => import('./pages/Reports'));
const Settings = lazy(() => import('./pages/Settings'));
const Help = lazy(() => import('./pages/Help'));
const ArticleExample = lazy(() => import('./pages/ArticleExample'));
const BudgetArticle = lazy(() => import('./pages/BudgetArticle'));
const CreditCardInterestArticle = lazy(() => import('./pages/CreditCardInterestArticle'));
const EmergencyFundArticle = lazy(() => import('./pages/EmergencyFundArticle'));
const Sitemap = lazy(() => import('./pages/Sitemap'));

// Loading fallback
const LoadingFallback = () => (
  <div className="min-h-screen bg-gray-50 flex items-center justify-center">
    <div className="w-16 h-16 border-4 border-indigo-600 border-t-transparent rounded-full animate-spin"></div>
  </div>
);

function App() {
  return (
    <>
      <Helmet>
        <link rel="sitemap" type="application/xml" href="/sitemap.xml" />
      </Helmet>
      <Layout>
        <Suspense fallback={<LoadingFallback />}>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/calculator" element={<DebtCalculator />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/reports" element={<Reports />} />
            <Route path="/settings" element={<Settings />} />
            <Route path="/help" element={<Help />} />
            <Route path="/sitemap" element={<Sitemap />} />
            <Route path="/debt-payoff-strategies-snowball-vs-avalanche" element={<ArticleExample />} />
            <Route path="/how-to-create-debt-repayment-budget" element={<BudgetArticle />} />
            <Route path="/understanding-credit-card-interest-rates" element={<CreditCardInterestArticle />} />
            <Route path="/how-to-build-emergency-fund" element={<EmergencyFundArticle />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </Suspense>
      </Layout>
    </>
  );
}

export default App;